import { useQuery } from '@tanstack/react-query'
import { ordersGetFulfillmentOrderCountsOptions, type FulfillmentOrderCountsRoot } from '@repo/sdk'

const DEFAULT_COUNTS: FulfillmentOrderCountsRoot = {
  paymentPending: 0,
  paid: 0,
  shipped: 0,
  delivered: 0,
  confirmed: 0,
  allCancelled: 0,
}

export function useOrderTabCounts() {
  const { data, isLoading } = useQuery({
    ...ordersGetFulfillmentOrderCountsOptions({
      query: { role: 'DEALER' },
    }),
  })

  return {
    counts: data ?? DEFAULT_COUNTS,
    isLoading,
  }
}
